<div class="flex flex-col gap-4">
  @if (!datosListos()) {
    <div class="flex items-center justify-center py-8 text-gray-400">
      <i class="bi bi-arrow-repeat animate-spin text-xl mr-2"></i>
      <span class="text-sm">Cargando datos...</span>
    </div>
  } @else {
  @if (isCreacion()) {
  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-gray-700">Producto (plato)</label>
    <app-select [options]="opcionesProductosReceta()" [(value)]="productoRecetaSeleccionado" placeholder="Buscar plato..." [filter]="true" filterBy="label" [compareWith]="compareProductoById" styleClass="w-full" />
  </div>
  }

  @if (modoDuplicar()) {
  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-gray-700">Nombre de la copia</label>
    <input type="text" [ngModel]="nombreDuplicado()" (ngModelChange)="nombreDuplicado.set($event)" placeholder="Ej: Lomo Saltado de Pollo" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
  </div>
  }

  @if (modoEdicion()) {
  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-gray-700">Nombre</label>
    <input type="text" [ngModel]="nombreEdicion()" (ngModelChange)="nombreEdicion.set($event)" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
  </div>
  }

  <!-- Separador de ingredientes -->
  <div class="border-t border-gray-200 pt-4">
    <div class="flex justify-between items-center mb-3">
      <h3 class="text-sm font-semibold text-gray-800">Ingredientes</h3>
      <app-button label="Agregar ingrediente" icon="bi bi-plus" variant="info" size="sm" (onClick)="agregarIngrediente()" />
    </div>

    <!-- ═══ DESKTOP: Tabla de ingredientes horizontal ═══ -->
    @if (ingredientes.length > 0) {
      <div class="hidden lg:flex flex-col gap-2">
        @for (ing of ingredientes; track ing.tempId; let i = $index) {
          <div class="flex items-center gap-2 p-2 bg-gray-50 rounded border border-gray-200">
            <div class="flex-1 min-w-0">
              <app-select [options]="opcionesProductosIngrediente()" [(value)]="ing.producto" (onChange)="onIngredienteSeleccionado(i)" placeholder="Buscar ingrediente..." [filter]="true" filterBy="label" [compareWith]="compareProductoById" styleClass="w-full" />
            </div>
            <div class="w-20">
              <app-input-number [(value)]="ing.cantidad" [min]="0" placeholder="Cant." styleClass="w-full" />
            </div>
            <div class="w-36">
              <app-select [options]="unidadesCompatiblesParaIngrediente(ing)" [(value)]="ing.unidad" (onChange)="onUnidadIngredienteCambiada(i)" styleClass="w-full" />
            </div>
            <div class="w-24 text-right text-sm text-gray-500">
              @if (ing.costoUnitario > 0) { S/ {{ ing.costoUnitario | number: '1.2-4' }} }
            </div>
            <div class="w-24 text-right text-sm font-medium">
              @if (ing.cantidad > 0 && ing.costoUnitario > 0) { S/ {{ ing.cantidad * ing.costoUnitario | number: '1.2-2' }} }
            </div>
            <app-button icon="bi bi-x-lg" variant="danger" rounded size="sm" (onClick)="removerIngrediente(i)" />
          </div>
        }
      </div>

      <!-- ═══ MOBILE: Ingredientes en cards ═══ -->
      <div class="lg:hidden flex flex-col gap-3">
        @for (ing of ingredientes; track ing.tempId; let i = $index) {
          <div class="bg-gray-50 rounded-lg border border-gray-200 p-3 flex flex-col gap-2">
            <div class="flex items-center justify-between">
              <span class="text-xs font-semibold text-gray-500 uppercase">Ingrediente {{ i + 1 }}</span>
              <button type="button" class="text-red-500 p-1" (click)="removerIngrediente(i)"><i class="bi bi-x-lg"></i></button>
            </div>
            <app-select [options]="opcionesProductosIngrediente()" [(value)]="ing.producto" (onChange)="onIngredienteSeleccionado(i)" placeholder="Buscar ingrediente..." [filter]="true" filterBy="label" [compareWith]="compareProductoById" styleClass="w-full" />
            <div class="flex gap-2">
              <div class="flex-1">
                <label class="text-[11px] text-gray-500 mb-0.5 block">Cantidad</label>
                <app-input-number [(value)]="ing.cantidad" [min]="0" placeholder="Cant." styleClass="w-full" />
              </div>
              <div class="flex-1">
                <label class="text-[11px] text-gray-500 mb-0.5 block">Unidad</label>
                <app-select [options]="unidadesCompatiblesParaIngrediente(ing)" [(value)]="ing.unidad" (onChange)="onUnidadIngredienteCambiada(i)" styleClass="w-full" />
              </div>
            </div>
            <div class="flex justify-between text-xs text-gray-500">
              @if (ing.costoUnitario > 0) { <span>Costo unitario: S/ {{ ing.costoUnitario | number: '1.2-4' }}</span> }
              @if (ing.cantidad > 0 && ing.costoUnitario > 0) { <span class="font-medium text-gray-700">Subtotal: S/ {{ ing.cantidad * ing.costoUnitario | number: '1.2-2' }}</span> }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="text-center text-gray-400 py-4 border border-dashed border-gray-300 rounded">
        <i class="bi bi-basket text-2xl block mb-1"></i>
        <p class="text-sm">No hay ingredientes. Agrega al menos uno.</p>
      </div>
    }
  </div>

  @if (ingredientes.length > 0) {
    <div class="flex justify-end border-t border-gray-200 pt-3">
      <span class="text-sm font-bold">Costo total estimado: S/ {{ costoTotal() | number: '1.2-2' }}</span>
    </div>
  }

  <div class="flex justify-end gap-2 pt-2">
    <app-button label="Cancelar" variant="outline" (onClick)="cancelar()" [disabled]="guardando()" />
    <app-button label="Guardar" icon="bi bi-check-lg" variant="success" (onClick)="guardar()" [loading]="guardando()" />
  </div>
  }
</div>
